var _Glyphicon, _Text, _hr, _span, _InfoIcon, _Glyphicon2, _hr2;
import PropTypes from 'prop-types';
import React, { Fragment, createElement as _createElement } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import _get from 'lodash/get';
import { Button, Glyphicon, InfoIcon, List, LinkTile, OverlayTrigger, Popover, Text } from 'reaxl';
import { OwnerAddress, OwnerDistance, OwnerPhoneNumber } from 'reaxl-molecules';
import { EsntialBuyNowCTA } from 'reaxl-wallet';
import { homeServicesConfig as homeServices } from 'reaxl-home-services';
import { EmailCTA, OneClickButton } from 'reaxl-email';
import { useFeatures } from '@atc/features';
import { sendClick } from 'reaxl-analytics';
import { inventoryListingViewEllipsesClick } from 'reaxl-analytics-handlers';
import { useBrand } from '@atc/brand';
import { fallbackInterestRates } from 'axl-config';
import DealerDiffCTA from '../DealerDiffCTA/index.js';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const renderSellerPhone = _ref => {
  let {
    enableScripts,
    enableCadNitrous,
    isCallable,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex",
    children: /*#__PURE__*/_jsx(OwnerPhoneNumber, {
      className: "display-block",
      "data-nitrous-element-name": enableScripts && enableCadNitrous && isCallable ? 'Call (Search Results)' : undefined,
      ...props
    }, "listingFooterOwnerPhone")
  });
};
const renderDealerDiffCTA = _ref2 => {
  let {
    dealerDiffCTA,
    onDealerDiffCTAClick,
    isDealerDiffDisabled
  } = _ref2;
  const showDealerDiffCTA = dealerDiffCTA && dealerDiffCTA.label && onDealerDiffCTAClick;
  return showDealerDiffCTA && !isDealerDiffDisabled && /*#__PURE__*/_jsx(DealerDiffCTA, {
    onDealerDiffCTAClick: onDealerDiffCTAClick,
    ...dealerDiffCTA
  }, "dealerDiffCTA");
};
const renderTiles = _ref3 => {
  let {
    listing,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onProductTileClick,
    onProductTileLinkClick,
    enableCpoVhrBadges,
    isFord
  } = _ref3;
  const productTiles = listing.productTiles && listing.productTiles.map((tile, i) => /*#__PURE__*/_createElement(LinkTile, {
    ...tile,
    imageHeight: isFord ? '30' : '20',
    imageWidth: isFord ? '90' : '65',
    isProductTile: true,
    onTileClick: event => onProductTileClick(event, listing),
    onLinkClick: event => onProductTileLinkClick(event, listing),
    className: "margin-right-2",
    key: `product-tile-${i}`
  }));
  const certifiedTiles = listing.certifiedTiles && listing.certifiedTiles.map((tile, i) => /*#__PURE__*/_createElement(LinkTile, {
    ...tile,
    imageHeight: isFord ? '30' : '20',
    imageWidth: isFord ? '103' : '73',
    onTileClick: event => onCertifiedTileClick(event, listing),
    onLinkClick: event => onCertifiedTileLinkClick(event, listing),
    linkVisible: false,
    className: "margin-right-2",
    key: `certified-tile-${i}`
  }));
  return /*#__PURE__*/_jsxs("div", {
    className: "display-flex",
    children: [!enableCpoVhrBadges && productTiles, ' ', isFord && certifiedTiles]
  });
};

/* render home services in same order they appear in axl-config
 * 1) virtual tour 2) test drive 3) home delivery
 */
const renderHomeServices = _ref4 => {
  let {
    className,
    owner,
    shippingLabel
  } = _ref4;
  const {
    testDrive,
    vehicleDelivery
  } = homeServices;
  const hasHomeDelivery = _get(owner, 'homeServices.vehicleDelivery', false) && !shippingLabel;
  const hasTestDrive = _get(owner, 'homeServices.testDrive', false);
  const servicesList = [];
  const getAtHomeServicesDealerProducts = () => {
    if (hasTestDrive) {
      servicesList.push(testDrive.title);
    }
    if (hasHomeDelivery) {
      servicesList.push(vehicleDelivery.title);
    }
    return servicesList;
  };
  const atHomeServices = getAtHomeServicesDealerProducts();
  return servicesList.length > 0 && /*#__PURE__*/_jsx("div", {
    className: className,
    "data-cmp": "dealerProducts",
    children: /*#__PURE__*/_jsx(List, {
      inline: true,
      items: atHomeServices,
      decorated: atHomeServices.length >= 2
    })
  }, "listingFooterDealerProducts");
};
const renderOnlineServices = _ref5 => {
  let {
    className,
    listing,
    owner,
    shippingLabel
  } = _ref5;
  const {
    accelerate: onlinePaperwork,
    buyOnline
  } = homeServices;
  const hasOnlinePaperwork = _get(listing, 'accelerate', false);
  const hasBuyOnline = _get(owner, 'homeServices.buyOnline', false);
  const isPrivateSeller = _get(listing, 'owner.privateSeller', false);
  const isIMEListing = _get(listing, 'marketExtension.imeDmaMatch', false);
  const servicesList = [];
  const getOnlineDealerProducts = () => {
    if (hasOnlinePaperwork) {
      servicesList.push(onlinePaperwork.title);
    }
    if (hasBuyOnline || isPrivateSeller) {
      servicesList.push(isPrivateSeller ? /*#__PURE__*/_jsx("span", {
        className: "display-inline-flex flex-nowrap",
        children: buyOnline.inventoryListingFooterTitle
      }) : buyOnline.title);
    }
    if (shippingLabel || isIMEListing) {
      servicesList.push(/*#__PURE__*/_jsxs(_Fragment, {
        children: [isIMEListing ? 'Delivery' : shippingLabel, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
          glyph: "delivery-truck",
          className: "text-size-400 margin-bottom-1 margin-horizontal-1 glyphicon-stack"
        }))]
      }));
    }
    return servicesList;
  };
  const onlineServices = getOnlineDealerProducts();
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "data-cmp": "dealerProducts",
    style: {
      height: 'var(--base-space-px-18)'
    },
    children: /*#__PURE__*/_jsx(List, {
      inline: true,
      items: onlineServices,
      className: "text-bold",
      decorated: onlineServices.length >= 2
    })
  }, "listingFooterDealerProducts");
};
const renderRequestAQuote = _ref6 => {
  let {
    listing,
    emailOwnerProps,
    isPreorder,
    orientation,
    owner
  } = _ref6;
  const showRequestAQuote = isPreorder && emailOwnerProps;
  const isPortrait = orientation === 'portrait';
  const classNames = clsx('align-items-center text-center', {
    'padding-bottom-3': !isPortrait,
    'padding-bottom-4 margin-top-3 w-100': isPortrait
  });
  return showRequestAQuote && /*#__PURE__*/_jsxs("div", {
    className: classNames,
    children: [/*#__PURE__*/_jsx(EmailCTA, {
      buttonStyle: "primary",
      className: "margin-bottom-3",
      labelKey: "quote",
      onClick: emailOwnerProps.onCTAClick,
      onBuildClick: emailOwnerProps.onBuildClick,
      type: "block",
      listingId: listing.id,
      ownerId: owner.id
    }, "quote"), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
      children: "For illustration purposes only. May not match exact trim or color of the vehicle shown. No obligation to purchase."
    }))]
  });
};
function RenderInventoryListingFooter(_ref7) {
  let {
    clickType,
    dealsDuck,
    paymentsDuck,
    interestRateDuck,
    saveDealXgFetcher,
    owner = {},
    listing,
    listingQuickActions,
    emailOwnerProps,
    handleEditEmail,
    isActiveDeal,
    isHyundaiBuyOnlinePage = false,
    isPhoneNumberCallable,
    isKbbBranded,
    phoneClickHandler,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onDealerDiffCTAClick,
    onProductTileClick,
    onProductTileLinkClick,
    oneClickEmailSent,
    orientation,
    parentId,
    secondaryContent,
    showDistance,
    showEditEmail,
    showEllipses,
    showSections,
    uiContext,
    paginatedListingIndex,
    onOnlinePaperworkClick,
    onSelectPsxListing,
    ...rest
  } = _ref7;
  const {
    call: [isCallEnabled],
    enable_cpo_vhr_badges: [, {
      show_cpo_vhr_badges: enableCpoVhrBadges
    }],
    email: [isEmailEnable, {
      override_hide_email: enableConfirmAvailabilityCta
    }],
    hyundai_buy_online: [enableHyundaiBuyOnline],
    srp_esntial_cta: [enableSRPEsntialCTA, {
      cta_label: esntialCtaLabel
    }],
    scripts: [enableScripts, {
      cadNitrous: enableCadNitrous
    }],
    dealer_diff_disabled: [isDealerDiffDisabled]
  } = useFeatures(['call', 'enable_cpo_vhr_badges', 'email', 'hyundai_buy_online', 'srp_esntial_cta', 'scripts', 'dealer_diff_disabled']);
  const environment = process.env.NODE_ENV === 'production' ? 'prod' : 'staging';
  const {
    isBrand
  } = useBrand();
  const isFord = isBrand('ford');
  const isIMEListing = _get(listing, 'marketExtension.imeDmaMatch', false);
  const selectedRates = useSelector(interestRateDuck ? interestRateDuck.selectors.getDuckState : () => null);
  const nationalRates = selectedRates || fallbackInterestRates;
  const {
    dealerDiff,
    distanceFromSearch,
    hideEmailForm,
    isVirtual,
    location,
    name,
    phone,
    privateSeller,
    shipToStore,
    shippingLabel,
    virtual
  } = owner;
  const displayOwnerName = listing.ownerName || name;
  const isPreorder = uiContext === 'preorder';
  const isPortrait = orientation === 'portrait';
  const isSimplifiedListing = uiContext === 'simplified';
  const isSponsoredListing = uiContext === 'sponsored';
  const city = location?.address?.city;
  const isBuyOnline = owner.homeServices?.buyOnline;

  // show email CTA only when dealer has a phone number
  // remove isVisible below once monolith is retired
  const phoneVisible = phone && (phone.visible || phone.isVisible);
  const isEmailCtaEnabled = isEmailEnable && enableConfirmAvailabilityCta;
  const isEmailEligible = !isPreorder && !privateSeller && emailOwnerProps && phoneVisible && !hideEmailForm;
  const showEmailOwnerCTA = isEmailCtaEnabled || isEmailEligible;
  const showEditEmailCTA = showEmailOwnerCTA && showEditEmail;
  const showContactInfo = uiContext !== 'snapshot' && (phone || showEmailOwnerCTA);
  const isDistanceViewable = !!distanceFromSearch && !(isVirtual || virtual) && showDistance;
  const isHyundaiBuyOnlineEligible = enableHyundaiBuyOnline && isHyundaiBuyOnlinePage;
  const classNames = clsx('static-height-footer', {
    'display-flex flex-column': isPortrait
  });
  const analyticsData = {
    par: parentId,
    inventoryId: listing.id,
    ownerId: owner.id,
    clickType,
    paginatedListingIndex
  };
  const ownerAddress = city && /*#__PURE__*/_jsx(OwnerAddress, {
    location: location,
    analyticsData: analyticsData
  });
  const atHomeServices = renderHomeServices({
    className: 'text-subdued margin-top-2',
    owner,
    shippingLabel
  });
  const popoverDealerDiffCTA = uiContext !== 'snapshot' && !isPreorder && renderDealerDiffCTA({
    dealerDiffCTA: dealerDiff,
    onDealerDiffCTAClick,
    isDealerDiffDisabled
  });
  const handleClick = event => {
    event.stopPropagation(); // Prevent ancestor React elements from receiving click
    event.preventDefault(); // Prevent ancestor <a> from navigating to VDP
    event.nativeEvent.stopImmediatePropagation(); // Prevent BIRF from navigating after click delay
  };
  const handleEllipsisClick = (event, data) => {
    sendClick(inventoryListingViewEllipsesClick, event, {
      ...data,
      inventoryId: listing?.id,
      par: parentId
    });
  };
  const handleSelectPsxListing = event => {
    event.stopPropagation();
    event.preventDefault();
    onSelectPsxListing(event, listing);
  };
  const ownerInfoList = [];
  if (displayOwnerName && !isIMEListing && (!isBuyOnline || privateSeller) && isDistanceViewable) {
    ownerInfoList.push(/*#__PURE__*/_jsx("div", {
      className: "display-flex align-items-center",
      children: /*#__PURE__*/_jsx(OwnerDistance, {
        className: "text-subdued",
        displayOwnerName: displayOwnerName,
        owner: owner,
        uiContext: "owner",
        showIcon: false,
        showOwnerDistance: showDistance,
        analyticsData: analyticsData
      })
    }, "ownerDistance"));
  }
  if (showContactInfo && isCallEnabled && !isPhoneNumberCallable && phone && !privateSeller && !isHyundaiBuyOnlineEligible) {
    ownerInfoList.push(/*#__PURE__*/_jsx("div", {
      className: "text-subdued display-flex",
      "data-cmp": "contactInfo",
      children: renderSellerPhone({
        phone,
        isCallable: isPhoneNumberCallable,
        analyticsData,
        phoneClickHandler
      })
    }, "listingFooterContactInfo"));
  }
  const renderOwnerName = () => {
    if (!displayOwnerName) return null;
    return /*#__PURE__*/_jsx("span", {
      className: "padding-left-1 ellipsis-truncated",
      children: isSponsoredListing ? `Sponsored by ${displayOwnerName}` : displayOwnerName
    });
  };
  const customPopover = showEllipses && /*#__PURE__*/_jsxs(Popover, {
    id: "inventoryFooterPopover",
    className: "quick-actions-popover",
    onClick: e => e.stopPropagation(),
    onCloseClick: () => {},
    children: [/*#__PURE__*/_jsxs("div", {
      className: "text-subdued-lightest text-size-200",
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-subdued text-bold",
        children: renderOwnerName()
      }), /*#__PURE__*/_jsx(List, {
        items: ownerInfoList,
        inline: true,
        className: "margin-bottom-1 display-block text-size-200"
      }), ownerAddress && /*#__PURE__*/_jsx("div", {
        className: "padding-left-1",
        children: ownerAddress
      }), atHomeServices, popoverDealerDiffCTA]
    }), /*#__PURE__*/_jsxs("div", {
      className: "text-size-200",
      children: [ownerAddress || popoverDealerDiffCTA || atHomeServices?.length > 0 ? _hr || (_hr = /*#__PURE__*/_jsx("hr", {
        className: "margin-bottom-4"
      })) : null, listingQuickActions]
    })]
  }, 'customPopover' + listing.id);
  const hasEcommWebsite = listing?.ecommWebsite?.href;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isSimplifiedListing && /*#__PURE__*/_jsxs("div", {
      className: classNames,
      "data-cmp": "cntnr-listing-footer",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-left margin-bottom-2",
        children: [shipToStore && (_span || (_span = /*#__PURE__*/_jsx("span", {
          className: "margin-right-1",
          children: "Can be shipped to"
        }))), /*#__PURE__*/_jsxs("div", {
          className: "text-subdued",
          children: [renderOwnerName(), shipToStore && (_InfoIcon || (_InfoIcon = /*#__PURE__*/_jsx(InfoIcon, {
            placement: "top",
            infoText: "This dealership might not have this vehicle on their lot right now, but they can have it shipped to them. Talk to the dealer to arrange it.",
            className: "margin-left-1"
          })))]
        }), /*#__PURE__*/_jsx("div", {
          className: "display-flex",
          children: /*#__PURE__*/_jsx(List, {
            items: ownerInfoList,
            inline: true,
            nolistdecoration: ownerInfoList.length < 2
          })
        }), uiContext !== 'alpha' && !isHyundaiBuyOnlineEligible && renderOnlineServices({
          className: 'text-subdued',
          listing,
          owner,
          shippingLabel
        })]
      }), uiContext !== 'snapshot' && uiContext !== 'alpha' && showSections.tiles && renderTiles({
        listing,
        onCertifiedTileClick,
        onCertifiedTileLinkClick,
        onProductTileClick,
        onProductTileLinkClick,
        enableCpoVhrBadges,
        isFord,
        ...rest
      }), renderRequestAQuote({
        listing,
        emailOwnerProps,
        isPreorder,
        orientation,
        owner
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "display-flex gap-2 margin-top-2",
      children: [(!enableSRPEsntialCTA || enableSRPEsntialCTA && !hasEcommWebsite) && showEmailOwnerCTA && !showEditEmail && /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(EmailCTA, {
          clickType: clickType,
          parentId: parentId,
          listingId: listing.id,
          context: emailOwnerProps.context,
          onClick: emailOwnerProps.onCTAClick,
          buttonStyle: "default",
          buttonSize: "small",
          className: "flex-1 display-flex",
          showIcon: false,
          type: "block",
          labelKey: emailOwnerProps.labelKey,
          "data-nitrous-element-name": enableScripts && enableCadNitrous && emailOwnerProps?.labelKey === 'checkAvailability' ? 'Request Info (Search Results)' : undefined
        }, "email-cta")
      }, "emailOwnerCTA"), showEditEmailCTA && /*#__PURE__*/_jsx(OneClickButton, {
        listingId: listing.id,
        oneClickEmailSent: oneClickEmailSent,
        handleEmailSendClick: emailOwnerProps.onCTAClick,
        handleEditSettingsClick: handleEditEmail,
        wrapperClassNames: "w-100 display-flex"
      }), isCallEnabled && phone && isPhoneNumberCallable && !privateSeller && renderSellerPhone({
        phone,
        isCallable: isPhoneNumberCallable,
        analyticsData,
        phoneClickHandler,
        uiContext: 'button',
        buttonStyle: 'default',
        buttonSize: 'small',
        buttonLabel: 'Call',
        enableScripts,
        enableCadNitrous
      }), !enableSRPEsntialCTA && privateSeller && onSelectPsxListing && /*#__PURE__*/_jsx(Button, {
        block: true,
        bsSize: "small",
        bsStyle: "default",
        "data-cmp": "btn-makeOffer",
        onClick: handleSelectPsxListing,
        children: "Make Offer"
      }), enableSRPEsntialCTA && hasEcommWebsite && /*#__PURE__*/_jsx(EsntialBuyNowCTA, {
        dealsDuck: dealsDuck,
        label: esntialCtaLabel,
        href: listing?.ecommWebsite?.href,
        analyticsData: {
          placement: 'srp-hyundai-experience',
          listingId: listing?.id
        },
        bsSize: "small",
        bsStyle: "default",
        paymentsDuck: paymentsDuck,
        nationalRates: nationalRates,
        listing: listing,
        ownerTrackingId: listing?.ownerId,
        saveDealXgFetcher: saveDealXgFetcher,
        env: environment,
        block: true
      }), showEllipses && /*#__PURE__*/_jsx(OverlayTrigger, {
        onClick: handleClick,
        trigger: "click",
        rootClose: true,
        placement: "top",
        overlay: customPopover,
        className: "margin-left-auto",
        children: /*#__PURE__*/_jsx(Button, {
          "data-cmp": "footerEllipses",
          bsSize: "small",
          onClick: handleEllipsisClick,
          className: "padding-horizontal-1",
          "aria-label": "More actions",
          children: _Glyphicon2 || (_Glyphicon2 = /*#__PURE__*/_jsx(Glyphicon, {
            glyph: "ellipsis-horizontal",
            className: "text-size-500"
          }))
        })
      })]
    }), secondaryContent]
  });
}
/**
 *  Describe the component
 *
 */
function InventoryListingFooter(_ref8) {
  let {
    clickType,
    dealsDuck,
    paymentsDuck,
    interestRateDuck,
    saveDealXgFetcher,
    emailOwnerProps = {},
    handleEditEmail = () => {},
    isActiveDeal,
    isHyundaiBuyOnlinePage = false,
    isKbbBranded,
    isPhoneNumberCallable,
    listing,
    listingQuickActions,
    oneClickEmailSent = false,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onDealerDiffCTAClick,
    onOnlinePaperworkClick = () => {},
    onProductTileClick,
    onProductTileLinkClick,
    orientation,
    paginatedListingIndex,
    parentId,
    phoneClickHandler = () => {},
    secondaryContent,
    showDealerServices,
    showDistance = true,
    showEditEmail = false,
    showEllipses = false,
    showSections = {
      tiles: true
    },
    uiContext,
    onSelectPsxListing,
    ...rest
  } = _ref8;
  delete rest.secondaryContent;

  // Destructure listing data object
  const {
    owner = {}
  } = listing;
  const {
    phone
  } = owner;
  const ownerInfo = {
    owner,
    emailOwnerProps,
    parentId,
    phone,
    isPhoneNumberCallable,
    listing,
    orientation
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "listing-footer text-subdued-lightest text-size-100 padding-horizontal-3",
    ...rest,
    children: [uiContext !== 'simplified' && (_hr2 || (_hr2 = /*#__PURE__*/_jsx("hr", {}))), RenderInventoryListingFooter({
      ...ownerInfo,
      clickType,
      dealsDuck,
      paymentsDuck,
      interestRateDuck,
      saveDealXgFetcher,
      handleEditEmail,
      phoneClickHandler,
      isHyundaiBuyOnlinePage,
      isKbbBranded,
      listing,
      listingQuickActions,
      uiContext,
      oneClickEmailSent,
      onDealerDiffCTAClick,
      onCertifiedTileClick,
      onCertifiedTileLinkClick,
      onProductTileClick,
      onProductTileLinkClick,
      secondaryContent,
      showSections,
      showEditEmail,
      showEllipses,
      showDistance,
      paginatedListingIndex,
      onOnlinePaperworkClick,
      onSelectPsxListing,
      ...rest
    })]
  });
}
export default /*#__PURE__*/React.memo(InventoryListingFooter);